import { RouteRecordRaw } from "vue-router";
import BasicLayout from "@/layouts/BasicLayout.vue";
import UserLayout from "@/layouts/UserLayout.vue";
import HomePage from "@/views/HomePage.vue";
import ACCESS_ENUM from "@/access/accessEnum";
// 懒加载组件（路由按需加载，减少首屏 bundle 体积）
const NoAuthPage = () => import("@/views/NoAuthPage.vue");
const UserLoginPage = () => import("@/views/user/UserLoginPage.vue");
const UserRegisterPage = () => import("@/views/user/UserRegisterPage.vue");
const AdminConsolePage = () => import("@/views/admin/AdminConsolePage.vue");
const SpaceInterviewPage = () => import("@/views/space/SpaceInterviewPage.vue");
const SpaceResultPage = () => import("@/views/space/SpaceResultPage.vue");
const SpaceCreatePage = () => import("@/views/space/SpaceCreatePage.vue");

export const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    component: BasicLayout,
    children: [
      {
        path: "",
        name: "主页",
        component: HomePage,
        meta: {
          hideInMenu: true,
        },
      },

      // 用户相关
      {
        path: "space/create",
        name: "Agent 创建议题",
        component: SpaceCreatePage,
        meta: { access: ACCESS_ENUM.USER, immersiveWorkspace: true },
      },
      {
        path: "s/:slug",
        name: "参与议题",
        component: SpaceInterviewPage,
        props: true,
        meta: { hideInMenu: true },
      },
      {
        path: "s/:slug/results",
        name: "议题结果",
        component: SpaceResultPage,
        meta: { hideInMenu: true },
      },
      {
        path: "profile",
        redirect: "/account/profile",
        meta: {
          access: ACCESS_ENUM.USER,
          hideInMenu: true,
        },
      },
      {
        path: "settings",
        redirect: "/account",
        meta: { access: ACCESS_ENUM.USER, hideInMenu: true },
      },
      { path:"account",name:"我的空间",component:()=>import("@/views/account/AccountHubPage.vue"),meta:{access:ACCESS_ENUM.USER,hideInMenu:true}},
      { path:"avatar/edit",name:"更换头像",component:()=>import("@/views/user/AvatarEditPage.vue"),meta:{access:ACCESS_ENUM.USER,hideInMenu:true}},
      { path:"account/:section",redirect:"/account",meta:{access:ACCESS_ENUM.USER,hideInMenu:true}},

      // 应用相关
      {
        path: "app/create",
        name: "创建应用",
        redirect: "/space/create",
        meta: {
          access: ACCESS_ENUM.USER,
        },
      },
      {
        path: "app/edit/:id",
        name: "修改应用",
        redirect: "/space/create",
        meta: {
          access: ACCESS_ENUM.USER,
          hideInMenu: true,
        },
      },
      {
        path: "answer/my",
        redirect: "/account/records",
        meta: {
          access: ACCESS_ENUM.USER,
        },
      },

      // 后台管理
      { path: "admin", name: "管理后台", component: AdminConsolePage, meta: { access: ACCESS_ENUM.ADMIN } },
      {
        path: "admin/user",
        name: "用户管理",
        redirect: "/admin?tab=users",
        meta: {
          access: ACCESS_ENUM.ADMIN,
        },
      },
      {
        path: "admin/app",
        name: "应用管理",
        redirect: "/admin?tab=spaces",
        meta: {
          access: ACCESS_ENUM.ADMIN,
        },
      },

      // 权限页
      {
        path: "no-auth",
        name: "无权限",
        component: NoAuthPage,
        meta: {
          hideInMenu: true,
        },
      },
    ],
  },

  {
    path: "/user",
    name: "用户",
    component: UserLayout,
    meta: {
      hideInMenu: true,
    },
    children: [
      {
        path: "login",
        name: "用户登录",
        component: UserLoginPage,
        meta: {
          hideInMenu: true,
        },
      },
      {
        path: "register",
        name: "用户注册",
        component: UserRegisterPage,
        meta: {
          hideInMenu: true,
        },
      },
    ],
  },
];
